import { Card } from "@/components/ui/card";

interface Feature {
  name: string;
  description: string;
}

interface Section {
  name: string;
  features: Feature[];
}

interface FeatureCardsProps {
  sections: Section[];
}

export const FeatureCards = ({ sections }: FeatureCardsProps) => {
  if (!sections || sections.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {sections.map((section, index) => (
        <Card key={index} className="p-4">
          <h2 className="text-lg font-semibold mb-2">{section.name}</h2>
          <div className="space-y-2">
            {section.features.map((feature, featureIndex) => (
              <div key={featureIndex} className="p-2 hover:bg-gray-100 rounded">
                <p className="font-medium">{feature.name}</p>
                <p className="text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
};